const state = {
    sideBar: {
        collapsed: true
    }
};

const getters = {
    sideBarCollapsed: state => state.sideBar.collapsed
};

const actions = {
    toggleSidebar({ commit }) {
        commit('toggleSidebar')
    }
};

const mutations = {
    toggleSidebar: (state) => state.sideBar.collapsed = !state.sideBar.collapsed
};

export default {
    state,
    getters,
    actions,
    mutations
};